module.exports = __webpack_public_path__ + "static/media/outsourcing.2c0b7c2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/outsourcing.jpg
// module id = 354
// module chunks = 0